module.exports = __webpack_public_path__ + "img/CHEVRON_TOP.6abadf48.svg";